import React from 'react';
import useOAuthAuthorizePage from "v4/pages/front/OAuth/components/OAuthAuthorizePage/hooks/useOAuthAuthorizePage";
import Loading from "components/Loading/Loading";

export default function OAuthAuthorizePage() {
    useOAuthAuthorizePage();

    return (
        <div style={{height: '100dvh', display: 'grid', placeItems: 'center', background: 'white'}}>
            <div style={{width: '28.5%'}}>
                <Loading/>
            </div>
        </div>
    )
}
